// extracted by mini-css-extract-plugin
module.exports = {"pageContainer":"layout_pageContainer__16fyA","fixedWidth":"layout_fixedWidth__2P3NH"};